import type { ReactNode } from 'react';

import { TripTypeEnum, VehicleType } from '@mopla/data-models';

import { TVehicleIconSize, VehicleIcon } from '../../icons/Vehicles';

export const renderMainTransportIcon = (
	firstLeg: {
		mode: TripTypeEnum | 'MIXED';
		duration?: number;
		vehicleType?: VehicleType;
	},
	size: TVehicleIconSize = 'm'
): ReactNode => {
	if (firstLeg.mode === TripTypeEnum.PRODT) {
		return (
			<VehicleIcon
				mode={TripTypeEnum.PRODT}
				vehicleType={firstLeg.vehicleType ?? VehicleType.ECONOMY}
				size={size}
			/>
		);
	}

	if (firstLeg.mode === TripTypeEnum.LBODTFLEX) {
		return (
			<VehicleIcon
				mode={TripTypeEnum.LBODTFLEX}
				vehicleType="LBODTFLEX_WITH_PASSENGERS"
				size={size}
			/>
		);
	}

	return <VehicleIcon mode={firstLeg.mode} size={size} />;
};
